import React, { Component } from "react";
import { Translation, withTranslation } from "react-i18next";
import Bounce from "react-reveal/Bounce";
import { toast } from "react-toastify";
import { SnippetDataQuery } from "../../constants/apiParams";
import apiCall, { METHOD } from "../../constants/baseUrl";
import { stringToHTML } from "../../util/utils";

class ConditionDialogue extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      nestedSnippetData: {},
      content: {},
      allow_zero: false,
      options: [],
      value: [],
      option_raw_value:[]
    };
  }

  handleLoader = (status) => {
    this.setState(() => {
      return {
        isLoading: status,
      };
    });
  };

  componentDidMount() {
    const { id } = this.props;
    // alert(id)
    apiCall(
      METHOD.QUERY,
      SnippetDataQuery(id),
      (data) => {

        let contentObject = JSON.parse(data.content);
        let hide_on_zero = JSON.parse(contentObject.hide_on_zero);
        console.log("content111", (contentObject.content_option));

        let optionWithValue = JSON.parse(
          JSON.parse(contentObject.options)
        );

        let option_raw_value = (
          (contentObject.raw_value)
        );
        console.log("allow_zero", hide_on_zero);
        console.log("optionWithValue", option_raw_value);

        let options = [];
        let value = [];
        for (var key in optionWithValue) {
          options.push(key);
          value.push(optionWithValue[key]);
        }


        this.setState({
          nestedSnippetData: contentObject,
          content: contentObject.content,
          hide_on_zero,
          options,
          value,
          option_raw_value,
          raw_value: JSON.parse(JSON.parse(data.raw_value)),
        });
      },
      (isLoading) => { },
      (data) => {
        toast.error(this.props.t(data.message));
      }
    );
  }

  handleChange = (e) => {
    let value = e.target.value;
    if (e.target.checked) {
      this.setState((prev) => ({
        checkOption: [...prev.checkOption, value],
      }));
    } else {
      this.setState((prev) => ({
        checkOption: prev.checkOption.filter((d) => d != value),
      }));
    }
  };

  handleSubmit = (index) => {
    const {
      setDynamicValue,
      setFinalDynamicValueWithInnerSnippet,
      closeDialogue,
      reference, id
    } = this.props;
    const { content, value, raw_value, option_raw_value } = this.state;
    let snippet_raw_value = raw_value
    let reference_raw_value = JSON.parse(option_raw_value[index])
    let text = reference_raw_value.blocks[0].text
    let value_tag_potion
    if (reference_raw_value.blocks[0].entityRanges.length > 0) {
      
    let entityRanges = reference_raw_value.blocks[0].entityRanges
    let entityMap = reference_raw_value.entityMap
    let value_text = snippet_raw_value.blocks[0].text
       value_tag_potion = value_text.search("<value>")
     // alert(value_tag_potion)
    value_text = value_text.replace("<value>", text);


    const new_offset_val = entityRanges[0].offset + value_tag_potion

      
      
      
    let updated_entityRanges = entityRanges
    updated_entityRanges[0].offset = new_offset_val

    snippet_raw_value.entityMap = entityMap
    snippet_raw_value.blocks[0].entityRanges = updated_entityRanges
    snippet_raw_value.blocks[0].text = value_text
    }
    let val = content
    val = val.replace("<value>", value[index]);


    if (val.includes("<refe")) {
      let innerReference = stringToHTML(val, Date.now());
      var children = innerReference.children;
      let referenceInSpan = children[0];

      referenceInSpan.onclick = (e) => {
        e.preventDefault();
        if (e.stopPropagation) e.stopPropagation();
        this.props.handleReferenceClick(referenceInSpan);
      };
      referenceInSpan.setAttribute("class", "reference-backgroupred");
      referenceInSpan.innerHTML = referenceInSpan.getAttribute("placeholder");
      setFinalDynamicValueWithInnerSnippet(
        id,
        text,
        snippet_raw_value,
        value_tag_potion
      );
    } else {
      
      let val1 = raw_value.blocks[0].text;
      let value_tag_position = val1.search("<value>")
      val1 = val1.replace("<value>", value[index]);
      setDynamicValue(id, val1, raw_value, value_tag_position, value[index]);
      
    }
    closeDialogue();
  };
  cancelDialogue = () => {
    const { setDynamicValue, closeDialogue, reference, id } = this.props;
    const { allow_zero } = this.state;
    // if (allow_zero) {
    //   setDynamicValue(id, "NAN");
    //   closeDialogue();
    // } else {
    //   closeDialogue();
    // }
    closeDialogue();
  };
  render() {
    const { closeDialogue } = this.props;
    const { nestedSnippetData, options, value } = this.state;
    const { content } = nestedSnippetData;
    return (
      <Translation ns="translation">
        {(t, { i18n }) => {
          return (
            <Bounce bottom>
              <div
                className="navbar-collapse collapse text-left bottom-half show"
                id="Brand-toggler"
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">
                      {nestedSnippetData.name && nestedSnippetData.name}
                    </h5>
                    <div className="d-flex ">

                      <button
                        type="button"
                        className="close"
                        onClick={this.cancelDialogue}
                        aria-label="Close"
                      >
                        <i className="zmdi zmdi-close zmdi-hc-fw font-30"></i>
                      </button>
                    </div>
                  </div>
                  <div className="modal-body">
                    <div className="text-center">
                      <ul className="navbar-nav mr-auto">
                        {options &&
                          options.map((item, index) => {
                            console.log("item", item);

                            return (
                              <li
                                className="nav-item pointer "
                                key={index}
                                onClick={() => {
                                  this.handleSubmit(index);
                                }}
                              >
                                <div className="d-flex align-items-center">
                                <span style={{ fontSize: '16px', marginRight: '3px', textAlign: 'left' }}>{"- "}</span>
                                  <span>{item}</span>
                                </div>
                              </li>
                            );
                          })}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </Bounce>
          );
        }}
      </Translation>
    );
  }
}
export default withTranslation()(ConditionDialogue);
